import { Box, TextField } from "@mui/material";
import { FastField, getIn, useFormikContext } from "formik";
import { useTranslation } from "react-i18next";
import PhoneInput from "./PhoneInput";

export default function TextInput({
  id,
  name,
  onChange,
  schema: { inputHelper } = {},
  locked,
}) {
  const { errors, touched, submitCount } = useFormikContext();
  const { t } = useTranslation();

  return (
    <Box sx={{ py: 0.75, px: 2 }}>
      <FastField name={id}>
        {({ field, form }) => {
          const error = getIn(errors, field.name);
          const isTouched = getIn(touched, field.name);
          const showError = (isTouched || submitCount > 0) && error;

          if (inputHelper === "phoneNumber") {
            return (
              <PhoneInput
                value={field.value}
                label={t(name)}
                error={Boolean(showError)}
                helperText={showError || ""}
                disabled={locked}
                onChange={(value) => form.setFieldValue(field.name, value)}
                onBlur={() => onChange(field.name, field.value)}
              />
            );
          }

          let inputType = "text";
          if (inputHelper === "password") {
            inputType = "password";
          } else if (inputHelper === "email") {
            inputType = "email";
          }

          return (
            <TextField
              {...field}
              type={inputType}
              size="small"
              label={t(name)}
              error={Boolean(showError)}
              helperText={showError || ""}
              disabled={locked}
              onChange={(e) => form.setFieldValue(field.name, e.target.value)}
              onBlur={() => onChange(field.name, field.value)}
              sx={{
                width: "100%",
                "& .MuiFormHelperText-root": {
                  marginLeft: 0,
                },
              }}
            />
          );
        }}
      </FastField>
    </Box>
  );
}
